<script>
    import {binaryDataUrl} from "../urls";

    export let value;
</script>
<img src={binaryDataUrl(value)} {...$$props}/>